
      if (window.location.protocol === 'file:') {
        console.error(
          '[FIX:file-protocol] Vite entrypoint requires HTTP. Run "npm run dev" and open http://127.0.0.1:5173/.',
        );
        window.addEventListener('DOMContentLoaded', () => {
          document.body.innerHTML = `
            <main style="max-width:720px;margin:10vh auto;padding:32px;font-family:Arial,sans-serif;line-height:1.6;color:#1d1e1c">
              <h1 style="font-size:32px;line-height:1.15">Откройте сайт через локальный сервер</h1>
              <p>Vite, Tailwind и Alpine не работают при открытии <code>index.html</code> через <code>file://</code>.</p>
              <pre style="overflow:auto;border-radius:6px;background:#1d1e1c;color:#fff;padding:20px">npm run dev</pre>
              <p>Затем откройте <a href="http://127.0.0.1:5173/">http://127.0.0.1:5173/</a>.</p>
            </main>
          `;
        });
      } else {
        await import('/src/app.js');
      }
    